module.exports = __webpack_public_path__ + "static/media/LoginLogo.f30258cd.png";